<template>
  <el-table :data="tableData" stripe style="width: 100%" ref="typeTable" border v-loading="typesLoading">
    <af-table-column prop="typeName" :label="$t('xing-hao-ming-cheng')"></af-table-column>
    <af-table-column prop="typeModel" :label="$t('xing-hao-dai-ma')"></af-table-column>
    <af-table-column prop="gunCount" :label="$t('chong-dian-qiang-shu-liang-0')"></af-table-column>
    <af-table-column prop="ratedPower" :label="$t('e-ding-gong-shuai')"></af-table-column>
    <af-table-column prop="outputVoltageRange" :label="$t('shu-chu-dian-ya-fan-wei-vdc')"></af-table-column>
    <af-table-column prop="outputCurrentRange" :label="$t('shu-chu-dian-liu-fan-wei-a')"></af-table-column>
    <!--                <af-table-column prop="chargingCurrentRangePerGun" label="每把枪均充电流范围（A）"></af-table-column>-->
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:saveOrUpdatePileType'])">{{ $t('xiang-qing-0') }}
        </el-button>
        <el-button size="mini" plain @click="typeEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:updatePileType'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" plain type="danger" @click="typeDelete(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:pileType:deletePileType'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      tableData:{},
      typesLoading:false,
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      typeEdit(index,row){
        this.$emit("typeEdit",index,row)
      },
      typeDelete(index,row){
        this.$emit("typeDelete",index,row)
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/typeManager/list.vue